import { createI18n } from 'vue-i18n'
import { Language } from '@/module/language'

const i18n: any = createI18n({
  legacy: true,
  locale: Language.get(),
  messages: {
    'zh-CN': {
      websiteTitle: 'Joyway商品库存销量统计',
      // langs
      en: '英文',
      zh: '中文',
      // login
      enterPassword: '请输入查看密码',
      confirm: '确认',
      // home
      salesInquiry: '销量查询',
      cherryDeviceInfo: 'CHERRY设备信息',
      upload: '上传',
      export: '导出',
      stockStatistics: '件商品库存可销天数不足{number}天',
      stockStatisticsExceed: '件商品库存可销天数超过{number}天',
      // sales: '销量',
      show: '查看',
      // salesTable
      productDisplay: '商品显示',
      allProduct: '全部商品',
      mainProduct: '重点商品',
      listShow: '列表显示',
      productCode: '存货编码',
      stockName: '存货名称',
      prdocutModel: '规格型号',
      productName: '商品名称',
      productColor: '颜色键轴',
      jdStock: '京东库存',
      tmStock: '天猫库存',
      u8Stock: 'u8库存',
      id: '序号',
      salesDetail: '销量详情数据',
      jdDataDays: '京东数据天数',
      jdDataDaysDesc: '显示商品有多少天的数据',
      tmDataDays: '天猫数据天数',
      tmDataDaysDesc: '显示商品有多少天的数据',
      salesGrowthFactor: '销量增长系数',
      returnRateMonth: '近一月退货率',
      stockCount: '库存总量',
      daysInStock: '库存可销天数',
      jdSales: '京东销量',
      tmSales: '天猫销量',
      countSales: '总销量',
      operate: '操作',
      setAsMainProduct: '设为重点商品',
      setAsNotMainProduct: '设为普通商品',
      jdDataAsOf: '京东数据截止到',
      tmallDataAsOf: '天猫数据截止到',
      u8DataAsOf: 'U8数据截止到',
      // salesChart
      salesStatistics: '销量统计',
      salesComparison: '销量对比',
      // startTime: '开始时间',
      // endTime: '线束时间',
      tm: '天猫',
      jd: '京东',
      count: '总销量',
      now: '本期',
      yoy: '同比',
      mom: '环比',
      statisticsByDay: '按日统计',
      statisticsByWeek: '按周统计',
      statisticsByMonth: '按月统计',
      // helpDesc
      calculationMethod: '计算方法：',
      salesGrowthFactorDesc: '根据近14天的销量，计算得出销量增长直线，直线的斜率，即为销量增长系数',
      salesGrowthFactorPositiveNumber: '当销量增长系数为正数时，销量为正增长，系数越大，销量增长幅度越大；',
      salesGrowthFactorNegativeNumber: '当销量增长系数为负数时，销量为负增长，系数越小，销量减少幅度越大。',
      stockCountDesc: '库存总量=京东库存+天猫库存+U8库存',
      returnRateFormula: '近1月退货率=近30日的总退货数/近30日的总销量',
      returnRateDesc: '当前只统计天猫的退货率',
      idBackgroundColor: '序号背景颜色：',
      productDays: '显示商品有多少天的数据',
      stockDaysFormula: '库存可销天数（D）=库存总数量/日均销售量',
      averageDailySales: '日均销售量：',
      averageDailySalesFormula: '最近14天的总销量的数据，去掉总销量最高的2天，总销量最低的2天，取平均值，即得日均销售量',
      backgroundColor: '颜色示意：',
      seriouslyOutOfStock: '严重缺货',
      inventoryShortage: '库存不足',
      notOutOfStock: '暂不缺货',
      inventoryBacklog: '库存积压',
      day: '天',
      stockDayStatus: '库存充足',
      stockDaysDesc: '若统计到日均销量为零，且库存总量不为零，则显示为库存充足；若统计到日均销量为零，且库存总量为零，则显示为0。',
      // stockBind
      notice: '提示',
      unboundProduct: '以下商品未绑定U8的存货编码，请先绑定，否则无法上传此文件的数据。',
      thirdCode: '存货编码(天猫）/自营SKU（京东）',
      u8StockCode: 'U8存货编码',
      unbound: '未绑定',
      unboundNotic: '若没有相应的U8的存货编码，请先上传最新的U8库存表，更新U8的存货编码，再上传此文件，再进行绑定。',
      cancel: '取消',
      // ts 中 日期插件
      sunday: '星期日',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sun: '日',
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六',
      jan: '1月',
      feb: '2月',
      mar: '3月',
      apr: '4月',
      may1: '5月',
      jun: '6月',
      jul: '7月',
      aug: '8月',
      sep: '9月',
      oct: '10月',
      nov: '11月',
      dec: '12月',
      january: '一月',
      february: '二月',
      march: '三月',
      april: '四月',
      may: '五月',
      june: '六月',
      july: '七月',
      august: '八月',
      september: '九月',
      october: '十月',
      november: '十一月',
      december: '十二月',
      uploadSuc: '上传成功',
      bindSuc: '绑定成功'
    },
    'en-US': {
      websiteTitle: 'Joyway merchandise inventory sales statistics',
      // langs
      en: 'English',
      zh: 'Chinese',
      // login
      enterPassword: 'Please enter the view password',
      confirm: 'Confirm',
      // home
      salesInquiry: 'Sales inquiry',
      cherryDeviceInfo: 'CHERRY device information',
      upload: 'Upload',
      export: 'Export',
      stockStatistics: 'There are less than {number} days in stock of the product',
      stockStatisticsExceed: 'The number of days that a product can be sold in stock exceeds {number} days',
      // sales: 'Sales',
      show: 'View',
      // salesTable
      productDisplay: 'Product show',
      allProduct: 'All products',
      mainProduct: 'Key commodities',
      listShow: 'List show',
      productCode: 'Inventory code',
      stockName: 'Inventory name',
      prdocutModel: 'Specification model',
      productName: 'Product name',
      productColor: 'Color and axis',
      jdStock: 'Jingdong inventory',
      tmStock: 'Tmall inventory',
      u8Stock: 'U8 inventory',
      id: 'SID',
      salesDetail: 'Detail',
      jdDataDays: 'JD data days',
      jdDataDaysDesc: 'Data showing how many days the product has',
      tmDataDays: 'Tmall data days',
      tmDataDaysDesc: 'Data showing how many days the product has',
      salesGrowthFactor: 'Sales growth factor',
      returnRateMonth: 'Return rate in the past month',
      stockCount: 'Total inventory',
      daysInStock: 'Available days in stock',
      jdSales: 'Jingdong sales',
      tmSales: 'Tmall sales',
      countSales: 'Total sales',
      operate: 'operating',
      setAsMainProduct: 'Set as key product',
      setAsNotMainProduct: 'Set as normal product',
      jdDataAsOf: 'JD data as of',
      tmallDataAsOf: 'Tmall data as of',
      u8DataAsOf: 'U8 data as of',
      // salesChart
      salesStatistics: 'Sales statistics',
      salesComparison: 'Sales comparison',
      // startTime: 'Starting time',
      // endTime: 'Harness time',
      tm: 'Tmall',
      jd: 'Jingdong',
      count: 'Total sales',
      now: 'This period',
      yoy: 'YoY',
      mom: 'MoM',
      statisticsByDay: 'Statistics by day',
      statisticsByWeek: 'Statistics by weekly',
      statisticsByMonth: 'Statistics by month',
      // helpDesc
      calculationMethod: 'Calculation method:',
      salesGrowthFactorDesc: 'According to the sales volume in the past 14 days, the sales growth straight line is calculated. The slope of the straight line is the sales growth coefficient',
      salesGrowthFactorPositiveNumber: 'When the sales growth coefficient is positive, sales are positive growth. The greater the coefficient, the greater the sales growth rate; ',
      salesGrowthFactorNegativeNumber: 'When the sales volume growth coefficient is negative, sales volume is negative growth. The smaller the coefficient, the greater the decline in sales.',
      stockCountDesc: 'Total inventory = Jingdong inventory + Tmall inventory + U8 inventory',
      returnRateFormula: 'Last month`s is rate of return = total returns in the last 30 days / total sales in the last 30 days',
      returnRateDesc: 'Currently only the return rate of Tmall is calculated',
      idBackgroundColor: 'Serial number background color:',
      productDays: 'Data showing how many days the product has',
      stockDaysFormula: 'Available days of inventory (D) = total inventory / average daily sales',
      averageDailySales: 'Average daily sales:',
      averageDailySalesFormula: 'For the total sales data of the last 14 days, please remove the 2 days with the highest total sales and the 2 days with the lowest total sales, and then take the average to get the average daily sales.',
      backgroundColor: 'Color indication:',
      seriouslyOutOfStock: 'Seriously out of stock',
      inventoryShortage: 'Inventory shortage',
      notOutOfStock: 'No out of stock',
      inventoryBacklog: 'Inventory backlog',
      day: 'Day',
      stockDayStatus: 'Adequate inventory',
      stockDaysDesc: 'If it is calculated that the average daily sales volume is zero and the total inventory is not zero, it is displayed as `Adequate inventory`; if the average daily sales volume is calculated to be zero and the total inventory is zero, it is displayed as 0.',
      // stockBind
      notice: 'Prompt',
      unboundProduct: 'The following products are not bound to U8 inventory code, please bind first, otherwise the data of the file will not be uploaded.',
      thirdCode: 'Inventory code (Tmall)/Self-operated SKU (JD)',
      u8StockCode: 'U8 inventory code',
      unbound: 'Unbound',
      unboundNotic: 'If there is no corresponding U8 inventory code, please upload the latest U8 inventory table first, update U8 inventory code, upload this file, and then bind.',
      cancel: 'Cancel',
      // ts 中 日期插件
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sun: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may1: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Aug',
      sep: 'Sep',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dec',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
      uploadSuc: 'Uploaded successfully',
      bindSuc: 'Bind successfully'
    }
  }
})

// /**
//  * @param {String} locale
//  */

// export async function loadMessages (locale: string) {
//   const messages = await import(`./../lang/${locale}`)

//   if (i18n.global.locale.value !== locale) {
//     i18n.global.locale.value = locale
//   }
//   i18n.global.setLocaleMessage(locale, messages)
// }

// (async function () {
//   await loadMessages('zh')
// })()

export default i18n
